module.exports = __webpack_public_path__ + "static/media/1006030.e489791d.png";